import { useRoutes } from 'react-router-dom';
import { protectedRoutes } from './protected';
import { publicRoutes } from './public';
import { useAppSelector } from '../hooks/reduxHooks';

export const AppRoutes = () => {
  const { userAuth } = useAppSelector((state) => state.auth);
  return useRoutes(userAuth ? protectedRoutes : publicRoutes);
};
